export class ListAzureCmkEligibleAppsResponse {
    'apps';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<AzureCmkEligibleApp>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureCmkEligibleAppsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
